import React from 'react';
import { LocalizedLink as Link, useI18nL10nContext } from 'gatsby-plugin-i18n-l10n';
import classNames from 'classnames';
import { FaXTwitter, FaLinkedin, FaSquareRss } from 'react-icons/fa6';
import { MENU_ELEMENTS } from './Menu';
import Image from '../Image';
import Line from './Line';


export default function Footer() {
    const { locale } = useI18nL10nContext();

    return (
        <div className="rounded-lg border-2 border-white p-6 text-sm">
            <div className="flex flex-row justify-center gap-4 max-md:hidden">
                { MENU_ELEMENTS.map(({ title, elements }) => (
                    <section key={title.props.id}>
                        <h5 className="text-certego-blue">{title}</h5>
                        <ul>
                            {elements.map(({ title: t, link }) => (
                                <li key={t.props.id}>
                                    <a href={link}>{t}</a>
                                </li>
                            ))}
                        </ul>
                    </section>
                ))}
            </div>
            <div className="my-2 max-md:hidden">
                <Line className="my-4" />
                <div className="flex justify-between items-center lg:px-12">
                    <div className="flex gap-4 max-lg:hidden">
                        {[
                            { image: 'ISO9001.webp', link: { 'en-GB': '/iso/Cert_391061123_iso_9001_en.pdf', 'it-IT': '/iso/Cert_391061123_iso_9001_it.pdf' }, className: 'bg-certego-white p-1 rounded' },
                            { image: 'ISO27001.webp', link: { 'en-GB': '/iso/Cert_3917107_iso_27001_en.pdf', 'it-IT': '/iso/Cert_3917107_iso_27001_it.pdf' }, className: 'bg-certego-white p-1 rounded' },
                            { image: 'about-us/certifications/star.webp', link: 'https://cloudsecurityalliance.org/' },
                            { image: 'about-us/certifications/csa_tcp.webp', link: 'https://cloudsecurityalliance.org/' },
                            { image: 'about-us/certifications/csirt.webp', link: 'https://tf-csirt.org/' },
                            { image: 'about-us/certifications/europe.webp', link: 'https://www.digitalsme.eu/cybersecurity-label/' },
                            { image: 'about-us/certifications/first.webp', link: 'https://www.first.org/' },
                            { image: 'about-us/certifications/mssp_alert.webp', link: 'https://www.msspalert.com/top250/list-2022/' },
                        ].map(({
                            image, text, link, className,
                        }) => (
                            <a key={image} href={typeof link === 'object' ? link[locale] : link} target="_blank" rel="noreferrer">
                                <Image img={image} className={classNames('mx-auto 2xl:max-h-[64px] max-h-[48px]', className)} />
                                {text && <div className="text-center">{text}</div>}
                            </a>
                        ))}
                    </div>
                    <div className="flex gap-3 text-2xl max-xl:hidden">
                        <a href="https://twitter.com/certego_irt" target="_blank" rel="noreferrer"><FaXTwitter /></a>
                        <a href="https://linkedin.com/company/certego" target="_blank" rel="noreferrer"><FaLinkedin /></a>
                        <Link to="/rss.xml" rel="noreferrer"><FaSquareRss /></Link>
                    </div>
                </div>
            </div>
            <div className="sm:flex justify-between md:px-12 gap-6 text-xs">
                <div className="my-2">
                    Copyright © {new Date().getFullYear()} www.certego.net
                    <br />
                    Certego S.R.L. · P.I. 03517100362
                    {[{
                        title: 'Privacy/Cookie Policy',
                        link: '/privacy/',
                    }, {
                        title: 'Privacy Policy Customer/Supplier',
                        link: '/privacy_customer_supplier/',
                    }, {
                        title: 'Recycle',
                        link: '/recycle/',
                    }].map(({ title, link }) => (
                        <div key={title}>
                            <Link to={link} className="hover:text-certego-gray underline">
                                {title}
                            </Link>
                        </div>
                    ))}
                </div>
                <div className="my-2 sm:text-end">
                    Certego S.R.L.
                    <br />
                    Address: Via F. Lamborghini 81, 41121 Modena (MO)
                </div>
            </div>
        </div>
    );
}
